import { HistoricalMedia } from './historicalMedia';
import { IAppState } from '../../../../core/redux/IAppState';
import * as R from 'ramda';
import { getErrorShortCircuit, getLoadingShortCircuit } from '../../../../core/redux/api/module';
import { ACTION_TYPE } from '../../../../core/redux/actionType';


/**
 * Returns all of the media history for a guest given a guestId
 * If the guest doesn't have any media history information it returns undefined
 * @param state
 * @param guestId
 */
export const getGuestMediaHistory = (
  state: IAppState,
  guestId: string | undefined,
): HistoricalMedia[] | undefined => R.filter(history => history.guestId === guestId, state.mediaHistories);

const MEDIA_HISTORY_STATUS = {
  active: 1,
};

export const isActiveHistoricalMedia = (media: HistoricalMedia) => media.statusCode === MEDIA_HISTORY_STATUS.active;

/**
 * Gets the loading media history for the given Guest ID if it exists, and if the guest ID isn't undefined. Perfect
 * for if you don't know if you even have a guest.
 */
export const getLoadingMediaHistory = getLoadingShortCircuit(ACTION_TYPE.MEDIA_HISTORY_REQUEST);


/**
 * Gets the error media history for the given Guest ID if it exists, and if the guest ID isn't undefined. Perfect
 * for if you don't know if you even have a guest.
 */
export const getErroredMediaHistory = getErrorShortCircuit(ACTION_TYPE.MEDIA_HISTORY_REQUEST);

/**
 * Gets the loading disabled media history for the given Guest ID if it exists, and if the guest ID isn't undefined. Perfect
 * for if you don't know if you even have a guest.
 */
export const getLoadingDisableMediaHistory = getLoadingShortCircuit(ACTION_TYPE.DISABLE_GUEST_MEDIA_REQUEST);

/**
 * Gets the error disable media history for the given Guest ID if it exists, and if the guest ID isn't undefined. Perfect
 * for if you don't know if you even have a guest.
 */
export const getErroredDisableMediaHistory = getErrorShortCircuit(ACTION_TYPE.DISABLE_GUEST_MEDIA_REQUEST);
